import { useEffect } from 'react';
import { useSetCapabilities } from './capabilities';
import { useRegisterHeaderExtensions } from './headerExtensions';

export function usePageCapabilities(capabilityOverrides = {}, headerExtensions = []) {
  const setCapabilities = useSetCapabilities();

  useEffect(() => {
    setCapabilities(capabilityOverrides);
    return () => setCapabilities({});
  }, [capabilityOverrides, setCapabilities]);

  useRegisterHeaderExtensions(headerExtensions);
}
